import relnotes from './relnotes';

export default relnotes;



// WEBPACK FOOTER //
// ./src/pages/static/relnotes/index.jsx